import { render, staticRenderFns } from "./Empregabilidade.vue?vue&type=template&id=0d8227fc&scoped=true&lang=pug&"
import script from "./Empregabilidade.vue?vue&type=script&lang=js&"
export * from "./Empregabilidade.vue?vue&type=script&lang=js&"
import style0 from "./Empregabilidade.styl?vue&type=style&index=0&id=0d8227fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8227fc",
  null
  
)

export default component.exports